import { Yup } from "@pharmupp/p3-front-commons"

export const getRequiredUserSchema = (errorMessage = "Un utilisateur est requis") =>
  Yup.object({
    id: Yup.string().uuid().typeError(errorMessage).required(errorMessage),
    firstName: Yup.string().required(),
    lastName: Yup.string().required(),
  }).typeError(errorMessage)
